export const settlements = (state) => state.settlements
export const selectedSettlements = (state) => state.selectedSettlements
export const selectAllField = (state) => state.selectAllField
export const totalSettlements = (state) => state.totalSettlements
